import { Injectable } from '@angular/core';

export type TMapObjectType = "" | "career" | "college" | "certification" | "military" | "cte" | "k12";

export interface IProjectedGrowth {
	name: string,
	display: string,
	img: string,
	color: string
}
export interface INameDisplay {
	name: string,
	display: string,
	percent?: number
}

@Injectable({
	providedIn: 'root'
})
export class MapService {

	private static projectedGrowths: IProjectedGrowth[] = [
		{ name: 'Slower than average', display: 'LOWER THAN AVERAGE', img: 'fa fa-arrow-down fa-1', color: '#dc4116' },
		{ name: 'Decline', display: 'LOWER THAN AVERAGE', img: 'fa fa-arrow-down fa-1', color: '#dc4116' },
		{ name: 'Average', display: 'ABOUT AVERAGE', img: 'fa fa-check fa-1', color: '#2b6091' },
		{ name: 'Little or no change', display: 'ABOUT AVERAGE', img: 'fa fa-check fa-1', color: '#2b6091' },
		{ name: 'Much faster than average', display: 'ABOVE AVERAGE', img: 'fa fa-arrow-up fa-1', color: '#77b713' },
		{ name: 'Faster than average', display: 'ABOVE AVERAGE', img: 'fa fa-arrow-up fa-1', color: '#77b713' },
		{ name: 'Little or no change', display: 'ABOVE AVERAGE', img: 'fa fa-arrow-up fa-1', color: '#77b713' }
	];

	public static convertProjectedGrowth(name: string): IProjectedGrowth {
		let o: IProjectedGrowth;
		try { o = this.projectedGrowths.find(x => x.name === name); }
		catch (ex) { ; }
		if (o == null || o === undefined) {
			return { name: '', display: '', img: '', color: '' };
		}
		else {
			return o;
		}
	}

	public static getProjectedGrowthIcon(growthAvg: string): string {
		let code:string = "";
		let o:any = null;
		//console.log(growthWord);
		if (typeof growthAvg !== 'undefined' && growthAvg !== null && growthAvg.length > 0) {
			try { o = this.projectedGrowths.find(x => x.name === growthAvg); }
			catch (ex) { ; }
			if (o != null) {
				code = '<span style="font-size:12px; color:#' + o.color + '"><i class="' + o.img + '"></i>&nbsp;' + o.display + '</span>';
			}
		}
		return code;
	}

	public static clusterImageSelector(name: string): string {
		let careerArea = true;
		if (!isNaN(parseInt(name))) {
			//temp solution for receiving both numeric and string
			name = name.toString();
			//numeric currently sent by college area
			careerArea = false;
		}
		name = (name == "21" || name == "Marketing, Sales & Service" || name == "Marketing") ? "assets/images/Clusters/marketing-circle-img-square.png" :
			(name == "13" || name == "Education & Training" || name == "Education") ? "assets/images/Clusters/education-icon.jpg" :
				(name == "14" || name == "Finance") ? "assets/images/Clusters/finance-icon.jpg" :
					(name == "19" || name == "Law, Public Safety, Corrections & Security" || name == "Law") ? "assets/images/Clusters/law-public-safety-icon.jpg" :
						(name == "23" || name == "Science, Technology, Engineering & Math" || name == "STEM") ? "assets/images/Clusters/stem-icon.jpg" :
							(name == "22" || name == "Government & Public Administration" || name == "Public Administration" || name == "Administration") ? "assets/images/Clusters/government-icon.jpg" :
								(name == "24" || name == "Transportation, Distribution & Logistics" || name == "Transportation") ? "assets/images/Clusters/transportation-icon.jpg" :
									(name == "18" || name == "Information Technology" || name == "IT") ? "assets/images/Clusters/information-tech-icon.jpg" :
										(name == "10" || name == "Agriculture, Food & Natural Resources" || name == "Agriculture") ? "assets/images/Clusters/agriculture-icon.jpg" :
											(name == "17" || name == "Human Services") ? "assets/images/Clusters/human-services-icon.jpg" :
												(name == "11" || name == "Architecture & Construction" || name == "Architecture") ? "assets/images/Clusters/architecture-icon.jpg" :
													(name == "12" || name == "Arts, A/V Technology & Communications" || name == "Arts") ? "assets/images/Clusters/arts-icon.jpg" :
														(name == "15" || name == "Health Science" || name == "Healthcare") ? "assets/images/Clusters/health-science-icon.jpg" :
															(name == "20" || name == "Manufacturing") ? "assets/images/Clusters/manufaturing-icon.jpg" :
																(name == "16" || name == "Hospitality and Tourism" || name == "Hospitality") ? "assets/images/Clusters/hospitality-icon.jpg" :
																	(name == "9" || name == "Business Management & Administration") ? "assets/images/Clusters/business-admin-icon.jpg" :
																		(careerArea === true) ? "assets/images/Clusters/career-circle-img-square.png" : "assets/images/Clusters/institution-icon.jpg";

		return name;
	}

	public static militaryClusterImageSelector(name: string): string {
		let imgPath = 'assets/images/Clusters/Military/';
		name = (name == "U.S. Marines" || name == "marine_corps") ? imgPath + "USMarines.png" :
			(name == "U.S. Air Force" || name == "air_force") ? imgPath + "USAirForce.png" :
				(name == "U.S. Coast Guard" || name == "coast_guard") ? imgPath + "USCoastGuard.png" :
					(name == "U.S. Navy" || name == "navy") ? imgPath + "USNavy.png" :
						(name == "U.S. Army" || name == "army") ? imgPath + "USArmy.png" : "";

		return name;
	}

	public static k12ClusterImageSelector(name: string): string {
		let imgPath = 'assets/images/K12/';
		name = (name === "Twelfth Grade" || name === "12") ? imgPath + "12.jpg" :
			(name === "Eleventh Grade" || name === "11") ? imgPath + "11.jpg" :
				(name === "Tenth Grade" || name === "10") ? imgPath + "10.jpg" :
					(name === "Ninth Grade" || name === "9") ? imgPath + "9.jpg" :
						(name === "Eighth Grade" || name === "8") ? imgPath + "8.jpg" :
							(name === "Seventh Grade" || name === "7") ? imgPath + "7.jpg" :
								(name === "Sixth Grade" || name === "6") ? imgPath + "6.jpg" :
									(name === "Fifth Grade" || name === "5") ? imgPath + "5.jpg" :
										(name === "Fourth Grade" || name === "4") ? imgPath + "4.jpg" :
											(name === "Third Grade" || name === "3") ? imgPath + "3.jpg" :
												(name === "Second Grade" || name === "2") ? imgPath + "2.jpg" :
													(name === "First  Grade" || name === "1") ? imgPath + "1.jpg" :
														(name === "K") ? "k.jpg" :
															"assets/images/Clusters/empty-icon.jpg";
		return name;
	}

	private static educationAttributes: INameDisplay[] = [
		{ name: 'AssociateDegreePercent', display: 'Associate\'s degree' },
		{ name: 'BachelorDegreePercent', display: 'College (4 Year)' },
		{ name: 'DoctoralDegreePercent', display: 'Doctoral degree' },
		{ name: 'HighSchoolDiplomaPercent', display: 'High school' },
		{ name: 'MasterDegreePercent', display: 'Master\'s degree' },
		{ name: 'PostBaccalaureateCertificatePercent', display: 'Post-baccalaureate certificate' },
		{ name: 'PostDoctoralTrainingPercent', display: 'Post-baccalaureate certificate' },
		{ name: 'PostMasterCertificatePercent', display: 'Post-master certificate' },
		{ name: 'PostSecondaryCertificatePercent', display: 'Professional degree certificate' },
		{ name: 'ProfessionalDegreePercent', display: 'Professional degree' },
		{ name: 'SomeCollegeNoDegreePercent', display: 'Some college' },
		{ name: 'UnderHighSchoolPercent', display: 'No high school diploma' }
	];

	public static getEducationAttributes(): INameDisplay[] {
		return JSON.parse(JSON.stringify(this.educationAttributes));
	}

	public static sortTop3Education(edu: any): string[] {
		let eduToSort: any[] = [];

		Object.keys(edu).forEach(x =>
			eduToSort.push({ "key": x, "value": edu[x] })
		);
		eduToSort = eduToSort.sort((a, b) => { return b.value - a.value; });
		eduToSort = eduToSort.slice(0, 3);
		let vals: string[] = [];
		for (var i = 0; i < eduToSort.length; i++) {
			MapService.educationAttributes.forEach((v) => {
				if (v.name === eduToSort[i].key) {
					vals.push(v.display + ' - ' + eduToSort[i].value + '%');
				}
			});
		}
		return vals;
	}
}



@Injectable({
	providedIn: 'root'
})
export class AssignCountryService {
	private countryNodes:any = null;

	getCountryNodesLocation(data:any) {
		this.countryNodes = {};
		this.countryNodes["career"] = { XLoc: data.CareerVersion.XLoc, YLoc: data.CareerVersion.YLoc };
		this.countryNodes["certification"] = { XLoc: data.CertificationVersion.XLoc, YLoc: data.CertificationVersion.YLoc };
		this.countryNodes["cte"] = { XLoc: data.CTEVersion.XLoc, YLoc: data.CTEVersion.YLoc };
		this.countryNodes["military"] = { XLoc: data.MilitaryVersion.XLoc, YLoc: data.MilitaryVersion.YLoc };
		this.countryNodes["college"] = { XLoc: data.CollegeVersion.XLoc, YLoc: data.CollegeVersion.YLoc };
		//k-8 and hs are handled as k-12 and hs
		this.countryNodes["k-12"] = { XLoc: data.K12Version.XLoc, YLoc: data.K12Version.YLoc };
		this.countryNodes["hs"] = { XLoc: data.K12Version.XLoc, YLoc: data.K12Version.YLoc };

		return this.countryNodes;
	};
}
